
























































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Branch } from '@/api/model/branch'

@Component
export default class CreateTeamForm extends Vue {
    @Prop({ required: true }) readonly value!: Branch
}
